export const defaultData = {
  modalHeader: "This course has been added to your cart",
  modalCta: "Proceed to checkout",
  promoBanner: {
    enabled: true,
    title: "Bundle and save!",
    subtitle: "Programs combine multiple courses into one discounted price.",
    CTA: "Go to cart",
  },
  welcomeBackModal: {
    enabled: true,
  },
};
export type ModalData = typeof defaultData;
